export const MODULES = '/module/' as const
export const MODULES_ALL = `${MODULES}all` as const
